import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice holding the currently active site entry.
 */
export const siteSlice = createSlice({
  name: 'site',

  initialState: {
    entry: { id: null }
  },

  reducers: {
    updateSite: (state, action) => {
      state.entry = action.payload
    },

    resetSite: state => {
      state.entry = { id: null }
    }
  }
})

/**
 * `updateSite` sets the active site entry; `resetSite` resets it to `{ id: null }`.
 */
export const { updateSite, resetSite } = siteSlice.actions

/**
 * Selects the currently active site entry.
 *
 * @param {Object} state - Redux state.
 * @returns {Object} Site entry (`{ id: null }` if none is active).
 */
export const site = state => state.site.entry
